import Lenis from 'lenis'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { prefersReducedMotion } from '@/lib/dom'

gsap.registerPlugin(ScrollTrigger)

// iOS Safari はスクロール中にアドレスバーが伸縮し、そのたびに resize が飛ぶ。
// 既定のままだと ScrollTrigger が全トリガーの位置を測り直してスクロールが引っかかるので、
// 「高さだけが変わった resize」は無視させる。幅が変わる本当の回転・リサイズには従来どおり反応する。
ScrollTrigger.config({ ignoreMobileResize: true })

/**
 * Lenis による慣性スクロールを初期化し、GSAP の ticker と ScrollTrigger に接続する。
 * ヘッダーのインライン onclick が `lenis.scrollTo(...)` を呼ぶため window にも公開する。
 */
export function initSmoothScroll(): Lenis {
  const lenis = new Lenis({
    duration: 1.2,
    easing: (t: number) => Math.min(1, 1.001 - 2 ** (-10 * t)),
    smoothWheel: !prefersReducedMotion(),
    touchMultiplier: 1.6,
  })

  lenis.on('scroll', ScrollTrigger.update)

  gsap.ticker.add((time: number) => {
    // GSAP の ticker は秒、Lenis の raf はミリ秒を期待する
    lenis.raf(time * 1000)
  })
  gsap.ticker.lagSmoothing(0)

  exposeLenis(lenis)
  return lenis
}

/**
 * `window.lenis` へインスタンスを載せる。
 * lenis パッケージが同名のプロパティを別の型で宣言しているため、ここで型を上書きする。
 */
function exposeLenis(lenis: Lenis): void {
  ;(window as unknown as WindowWithLenis).lenis = lenis
}

export { gsap, ScrollTrigger }
